import { api } from '@/lib/api'

import { PaymentRails } from '../constants'
import { BankEligibility } from '../types'

export function getBankEligibility(rails: PaymentRails = PaymentRails.EU) {
  return api.get<BankEligibility>(`/v1/me/bank-eligibility?rails=${rails}`)
}
